import { LocalModel } from "./local.model";

export class MarcacaoExameDisponibilidadeModel {
  id?: number;
  horario?: string;
  quantidadeVagas?: number;
  dataCadastro?: any;
  usuarioCadastro?: string;
  exame?: Exame;
  local?: LocalModel;
  situacao?: number;
  status?: string;
  codigoTurma?: string;
  ativo?: boolean;
  ativoBySituacao?: boolean;

  constructor(
    options: MarcacaoExameDisponibilidadeModel = {}
  ) {
    this.id = options.id || null;
    this.horario = options.horario || null;
    this.quantidadeVagas = options.quantidadeVagas || null;
    this.dataCadastro = options.dataCadastro || null;
    this.usuarioCadastro = options.usuarioCadastro || null;
    this.exame = options.exame || new Exame();
    this.local = options.local || new LocalModel();
    this.situacao = options.situacao || null;
    this.status = options.status || null;
    this.codigoTurma = options.codigoTurma || null;
    this.ativo = options.ativo || null;
    this.ativoBySituacao = options.ativoBySituacao || null;
  }
}


class Exame {
  id?: number;
  descricao?: string;
  constructor(options: Exame = {}) {
    this.id = options.id || null;
    this.descricao = options.descricao || null
  }
}
